import {InjectionToken} from "@angular/core";
import {AgendaelementModell, EntitetReferanseModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";

/** Definerer metoder fra ajs {@link WebNavigasjon} som vi benytter i ng2-koden */
export interface AjsWebNavigasjon {

    gåTilForsiden(): void;

    gåTilAdministrasjonSøk(): void;

    gåTilAdministrasjonAvtaler(): void;

    gåTilAdministrasjonBrukere(): void;

    gåTilAdministrasjonMeldinger(): void;

    gåTilAdministrasjonAsynkOppgaver(): void;

    gåTilAdministrasjonSpørreskjemaer(): void;

    gåTilGruppe(id: string): void;

    gåTilGruppeStatistikk(id: string): void;

    gåTilGruppeEndringshendelser(id: string): void;

    gåTilGrupper(): void;

    gåTilMedlem(gruppeId: string, medlemId: string): void;

    gåTilOpprettPlanMedPeriodeValgt(gruppeId: string, utcPeriode: { start: Date; slutt: Date }): void;

    gåTilSignerSaksdokument(dokumentId: string, erstattLokasjon?: boolean): void;

    gåTilSignerArkivdokument(dokumentId: string, erstattLokasjon?: boolean): void;

    gåTilSakKnyttetTilDokumentVersjon(dokumentVersjonId: string): void;

    gåTilArkivdokumentKnyttetTilDokument(dokumentId: string): void;

    gåTilArkivdokumentKnyttetTilDokumentVersjon(dokumentVersjonId: string): void;

    gåTilMøteProtokollFraProtokolldokumentISak(dokumentId: string): void;

    gåTilSakEllerArkivKnyttetTilDokumentVersjon(id: string): void;

    gåTilSak(id: string): void;

    gåTilSakOgDokument(møteId: string, sakId: string, dokumentId: string): void;

    gåTilBeslutning(id: string): void;

    gåTilSak2(møteId: string, sakId: string): void;

    gåTilAvstemning(avstemningId: string, sakId?: string, møteId?: string, erstattLokasjon?: boolean): void;

    gåTilListeSakerKnyttetTilTema(sak: Object /*AgendaelementModellDLM*/): void;

    gåTilListeSakerKnyttetTilSakstype(sak: Object /*AgendaelementModellDLM*/): void;

    gåTilMøte(id: string): void;

    gåTilMøteAvstemning(id: string): void;

    gåTilMøteProtokoll(id: string): void;

    gåTilRedigerMøteProtokoll(id: string, gjenopprettSkjema?: boolean, visGenerertForslag?: boolean): void;

    gåTilMøteEndringshendelser(id: string): void;

    gåTilOppgaveliste(spek: {
        grupper: string[];
        statuser: number[];
        ansvarlige: string[];
        ansvarligUtvalg: 'alle' | 'mine' | 'valgte';
        sortering?: { kolonne: number; retning: string },
        paginering?: { offsett: number; maksAntall: number; }
    }): void;

    gåTilOppgave(oppgave: string | Object /*OppgaveModell*/): void;

    gåTilGruppeMøtemal(id: string): void;

    gåTilGruppeMøtemalRediger(id: string): void;

    gåTilEntitetRef(entitetRef: EntitetReferanseModell): void;

    gåTilArkiv(mappeId: String): void;

    deaktiverNavigasjon(): void;

    reaktiverNavigasjon(): void;
}

export const ajs_WebNavigasjon_DI_TOKEN = new InjectionToken<AjsWebNavigasjon>('ajs WebNavigasjon');
